<template>
<div id="page-carga_adjuntos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar Adjuntos a Expediente" class="elevation-1 px-5 py-3" >
                   
                    <v-card-actions>
                        <v-spacer></v-spacer>                        
                            <exportar-excel :data="camposFacturaLayout" :exportFields="encabezadoFacturaLayout" name="Layout Facturas Pedimento.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Layout Facturas Pedimento" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>                        
                    </v-card-actions>
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <p class="text-justify" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            <strong>El archivo ZIP debe ser nombrado de la siguiente manera: 
                                                <br/> - Para pedimentos utilizar el formato: Aduana-Patente-Pedimento-AñoPedimento.zip (ej. 240-1234-9000005-2019.zip)
                                                <br/>Los nombres de los archivos dentro del ZIP no deben contener acentos ni caracteres especiales 
                                                    y deben tener un tipo de documento válido al inicio (Ver <v-btn small outlined text @click="showApendice()" >Apéndice de Tipos de Documentos</v-btn>, ej. 170_Factura123.xml)</strong>
                                        </p>

                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn @click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar</v-btn>
                                <v-btn v-if="false" color="success" >
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>

                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab :key="'bitacora'">Bitácora de Carga de Layout XSLX</v-tab>
                        <v-tab :key="'reportes'">Reporte de Layouts XLSX</v-tab>

                        <v-tab-item :key="'bitacora'" >
                            <br>
                            <v-card-text>    
                                <v-refresh-button :funcion="cargarBitacoraLayout" />                            
                                <v-client-table ref="vuetable" :data="datos_bitacora" :columns="columns_bitacora" :options="options_bitacora" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.filename!='' " @click="downloadFile(props.row.filename)" > 
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>                                        
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>

                        <v-tab-item :key="'reportes'" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>                                
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                    <v-row row wrap>
                                        <v-col sm="12" md="5" lg="5" >
                                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha de Carga Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                                :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu3 = false" >
                                                Cancelar
                                            </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="5" lg="5" >
                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha de Carga Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                                :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu4 = false" >
                                                Cancelar
                                            </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                        </v-col>
                                        <v-col sm="12" md="2" lg="2" >
                                            <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                                <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col>
                                            Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="10" lg="10">
                                            <v-combobox v-model="lista_filtrada" label="Lista de archivos" multiple persistent-hint small-chips disabled color="green">
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                    </v-container>
                                </v-form>
                                </v-card-text>
                                <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn color="success" @click="generar_reporte_sqs" >
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>
                                </v-card-actions>
                                <v-card-text>
                                <v-refresh-button :funcion="cargarReportes" />
                                <v-client-table ref="vuetable" :data="datos_reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                    <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                                        <v-icon dark>get_app</v-icon>
                                    </v-btn>
                                    <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                        <v-icon dark>delete</v-icon>
                                    </v-btn>
                                    </template>
                                </v-client-table>
                                </v-card-text>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </base-material-card>
            </v-flex>
        </v-layout>
        
    </v-container>

    <!-- MODAL Apendice-25-Tipos de Documentos -->
    <v-dialog v-model="modalApendice" max-width="80%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modalApendice = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Tipos de Documentos</strong>
                    </span>
                </v-card>                    
            </v-card-title>
            <v-card-text>
                <v-client-table ref="vuetableApendice" :data="apendice_items" :columns="columns" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>                                                                        
                </v-client-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalApendice = false" >
                    <v-icon>cancel</v-icon>Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog1" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea con formato: 000-0000-0000000</span><br>
        <small>*Usando esta opción no se tomará en cuenta el rango de fechas</small>
        <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
        this.permisoEliminar = true;          
        this.cargarBitacoraLayout();
    },
    data() {
        return {
            dialog1:false,
            lista_filtrada: [],
            menu3: false,
            menu4: false,
            permisoEliminar: false,
            model:{
                rfc:"",
                fecha_de: "",
                fecha_a: "",
                reporte_url: "/reportes/rpt_facturas_layout_xlsx/",
                nombre_reporte: "Facturas Layout XLSX",
                tipo: "Reporte_Layout_Facturas", 
                usuario: "",
                lista:"",
            },
            datos_bitacora: [], 
            datos_reportes: [],
            columns_bitacora: ["id", "created_at", "usuario", "pedimento", "anio", "archivo", "estatus", "error_text", "actions"],
            options_bitacora: {
                filterable: ["id", "created_at", "usuario", "pedimento", "anio", "archivo", "estatus", "error_text"],
                sortable: ["id", "created_at", "usuario", "pedimento", "anio", "archivo", "estatus", "error_text"],

                headings: {
                    id: "No. Proceso",
                    created_at: "Fecha de Creación",
                    usuario: "Usuario",
                    pedimento: "No. Pedimento",
                    anio: "Año",
                    archivo: "Nombre de Archivo",
                    estatus: "Estatus",
                    error_text: "Error",
                    actions: "Descargar"
                }
            },
            columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
            options_reportes: {
                filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
                sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

                headings: {
                    id: "No. Proceso",
                    fecha_solicitud: "Solicitado",
                    usuario_email: "Usuario",
                    nombre_reporte: "Reporte",
                    criterio: "Criterio de Búsqueda",
                    fecha_generacion: "Generado",
                    estatus: "Estatus",
                    error: "Error",
                    actions: "Descargar"
                }
            },
            fab: false,

            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "E-Drive",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Cargar Adjuntos Pedimento",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion", 
                "recibe_facturas",
                "recibe_layouts",           
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",
            
            encabezadoFacturaLayout: {
                tax_id:"tax_id",	
                fecha:"fecha",
                numero:"numero",	
                observaciones:"observaciones",
                secuencia:"secuencia",                
                descripcion:"descripcion",
                cantidad:"cantidad",
                um:"um",
                valor_unitario:"valor_unitario",
                subtotal:"subtotal",
                total_facturado:"total_facturado",	
                clave_moneda:"clave_moneda",
                marca:"marca",
                modelo:"modelo",
                submodelo:"submodelo",
                no_serie:"no_serie"
            },
            //van vacíos para solo descargar layout con encabezados
            camposFacturaLayout: [{
                tax_id:"[RFC o Tax ID del emisor]",	
                fecha:"[Fecha de Expedición en formato AAAA-MM-DD]",
                numero:"[Número de Factura]",	
                observaciones:"[Seguros | Fletes | Maniobras | Otros]",
                secuencia:"[Número de Partida secuencia de Factura]",                
                descripcion:"[Descripción]",
                cantidad:"[Cantidad]",
                um:"[Unidad de Medida]",
                valor_unitario:"[Valor en USD o MXN]",
                subtotal:"[Valor en USD o MXN]",
                total_facturado:"[Valor en USD o MXN]",	
                clave_moneda:"[Clave USD o MXN]",
                marca:"[Marca]",
                modelo:"[Modelo]",
                submodelo:"[Submodelo]",
                no_serie:"[Número de Serie]"
            },
            {
                tax_id:"[La información debe iniciar en esta fila - 3ra fila]",	
            }]

        };
    },

    methods: {
        verificaPedimento: function() {
            if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
                return true;
            }
            if (this.model.fecha_de == "" || this.model.fecha_a == "") {
                return "Favor de ingresar fechas o listado de pedimentos";
            }
            return true;
        },
        setListValues: function() {
            if(this.$refs.formListado.validate()){  
                this.lista_filtrada = [];
                let to_list = this.get_array_lista(this.model.lista);
                for (var i = 0; i < to_list.length; i++) {
                    if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                    } else {
                    this.lista_filtrada.push(to_list[i]);
                    }
                }
                this.model.fecha_de = "";
                this.model.fecha_a = "";
                this.dialog1 = !this.dialog1;
            }            
        },
        get_array_lista: function(cadena) {
            try {
                var newarr = [];
                if (cadena != undefined) {
                let data = cadena.split("\n");
                newarr = data.filter(a => a.trim() !== '');
                for (var i = 0; i < newarr.length; i++) {
                    newarr[i] = newarr[i].trim();
                    newarr[i] = newarr[i].replace(',', '');
                    newarr[i] = newarr[i].replace('.', '');
                }
                }
                return newarr;
            } catch (error) {
                console.log(error);
            }
        },
        maxListaRule: function() {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
            return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
            return "No se puede consultar mas de 50 pedimentos";
            } else if (x.length > 0) {
            for (var k in x) {
                if (!this.validarPatronPedimento(x[k]))
                return "Verificar pedimentos no válidos. Ejemplo correcto: 240-0123-0000123";
            }
            }

            return true;
        },
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        getCamposLayout: function () {
            axios
                .get(this.$hostname + "catalogos/templates/campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                    var valido = false;

                    if (nombre.length == 2){                        
                        split = nombre[0].split("-");
                        if (split.length == 4){
                            const patternPedimento = /^[0-9]+-{1}[0-9]+-{1}[0-9]+-{1}[0-9]+$/;
                            if (patternPedimento.test(nombre[0])){                                
                                valido = true;
                            }                            
                        } 
                    } 

                    if (valido == false){
                        this.reset();
                        this.$swal({
                            type: "warning",
                            title: "Favor de verificar",
                            text: "El archivo ZIP debe tener el nombre correcto con número de pedimento y año.",
                            footer: ""
                        });
                    } else {
                        
                        /*Se cambio para que lo suba directo a S3 y ya luego lo lea en la lambda*/
                        this.uploadFile(files[0], nombre[0]);                        

                        /*var thisObj = this;
                        const fr = new FileReader()
                        fr.readAsDataURL(files[0])

                        fr.addEventListener('load', () => {
                            this.file = fr.result; // this is an image file that can be sent to server...          
                            var n = this.file.search("base64,");
                            //Para dejar solo el archivo en base 64 y quitar laparte de "application/zip; base64,"
                            
                            if (n >= 0) {
                                this.file = this.file.substring(n + 7);
                            }
                            //console.log(this.file);
                            this.submitFile(nombre[0]);
                            
                        });*/
                        
                    }                    

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            
            var ped = referencia.split("-");
            var pedimento=ped[0]+"-"+ped[1]+"-"+ped[2];
            var anio=ped[3];
            var valida = {
                pedimento: pedimento, 
                anio: anio,
                rfc: this.$local_storage.get("rfc"),
            }
            var thisObj = this;
            axios.post(this.$hostname + 'reportes/valida_referencia_pedimento/', valida)
                .then((r)=>{
                    var keyFile = "bandeja_entrada/" + thisObj.name_file ;
                    
                    var datos = {
                        key: keyFile,
                        bucket: "production.econnect.ds",
                        type: thisObj.type_file
                    }
                    axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                        .then((res) => {
                            if (typeof res.data !== 'undefined') {                        
                                var urlput = res.data.mensaje;
                                //console.log(urlput);
                                axios.put(urlput, file, {headers:{'Content-Type': thisObj.type_file}})
                                .then((res) => {
                                    thisObj.submitFile(referencia, keyFile);                            
                                })                            
                                .catch((error)=>{
                                    thisObj.$root.$dialogLoader.hide();
                                    thisObj.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                        footer: '',
                                    });
                                    console.log(error);
                                });
                                
                            } else {
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                            }
                        })
                        .catch((error) => {
                            var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                mensaje = error.response.data.mensaje;
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: mensaje,
                                footer: '',
                            });
                            console.log(error);
                            thisObj.$root.$dialogLoader.hide();
                        });
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No existe o no tiene acceso a pedimento "+pedimento+" del año "+anio+". Favor de verificar.",
                        footer: '',
                    });
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });            

        },

        submitFile(referencia, keyFile) {   
            let formData = {
                key: keyFile,
                filename: this.name_file,
                tipo: 'mercancia',//Por default
                referencia: this.$local_storage.get("rfc") +"-"+referencia,
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };
            /*let formData = {
                key: "keystring",
                filename: "730-3658-0003766-2020.zip",
                tipo: 'mercancia',//Por default
                referencia: this.$local_storage.get("rfc") +"-730-3658-0003766-2020",
                user_updated: this.$local_storage.get("email"),
                usuario: this.$local_storage.get("id_usuario"),
            };*/
                         
            axios.post(this.$hostname + 'leexml/', formData)                            
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;                                
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {                        
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        showApendice(){
            if (this.apendice_items.length <= 0){            
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                                                
                    axios.post(this.$hostname + 'apendices/lista/', {tabla:25})
                        .then((res) => {
                            this.apendice_items = res.data;
                            for( var k in this.apendice_items){
                                if(this.apendice_items[k].recibe_facturas!=undefined && this.apendice_items[k].recibe_facturas==1)
                                    this.apendice_items[k].recibe_facturas = "Si";
                                else
                                    this.apendice_items[k].recibe_facturas = "No";
                                
                                if(this.apendice_items[k].recibe_layouts!=undefined && this.apendice_items[k].recibe_layouts==1)
                                    this.apendice_items[k].recibe_layouts = "Si";
                                else
                                    this.apendice_items[k].recibe_layouts = "No";
                            }
                            this.modalApendice =true;
                        })
                        .catch((error) => {                        
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al obtener los registros del apéndice",
                                footer: "",
                            });
                            console.log(error);                    
                        }).then(() => {                        
                            this.$root.$dialogLoader.hide();                        
                        });
            } else {
                this.modalApendice =true;
            }
        },
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function() {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (diferencia > 365)
                return "Periodo de consulta máximo, 1 año";
            }
            return true;
        },
        cargarReportes: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Reporte_Layout_Facturas"
            };            
            axios.post(this.$hostname + "reportes/get_reportes/", data)
                .then(res => {
                if (typeof res.data !== "undefined") {
                    this.datos_reportes = res.data;
                    this.datos_reportes.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                    });
                    for (var k in this.datos_reportes) {
                    this.datos_reportes[k].fecha_solicitud = this.parseDate(this.datos_reportes[k].fecha_solicitud);
                    this.datos_reportes[k].fecha_generacion = this.parseDate(this.datos_reportes[k].fecha_generacion);
                    this.datos_reportes[k].estatus = this.getEstatus(this.datos_reportes[k].estatus); 
                    this.datos_reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos_reportes[k].criterio);                   
                    }

                }
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los reportes.",
                    footer: ""
                });
                console.log(err);

                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
        },
        getCriterioPredeterminadosDS: function(criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var result = "";
                    var params = JSON.parse(criterio);
                    if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
                        result += "Busqueda por Lista.";
                    } else {
                        result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    }   
                    return result;                 
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        generar_reporte_sqs() {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model;

                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    data['lista'] = this.get_array_lista(data['lista']);
                    data['fecha_de'] = ""
                    data['fecha_a'] = ""
                }
                data["id_reporte"] = 77777777;
                axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",
                    //url: "http://127.0.0.1:7000/reportes/rpt_facturas_layout_xlsx/",
                    data: data
                })
                .then(response => {
                    this.$swal({
                    type: "success",
                    title: "Operación Exitosa",
                    text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                    footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                    mensaje = error.response.data.mensaje;
                    if (error.response.status == 406) {
                        titulo = "¡Ya existe un reporte en proceso!";
                        tipo = "info";
                    }
                    } else {
                    mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                    type: tipo,
                    title: titulo,
                    text: mensaje,
                    footer: ""
                    });
                }).then(() => {         
                    this.model.lista = '';
                    this.lista_filtrada = [];
                    this.cargarReportes();                    
                    this.$root.$dialogLoader.hide();
                });
            }
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        cargarBitacoraLayout: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc
            };            
            axios.post(this.$apiReportes + "reportes/get_facturas_layout/", data)
            //axios.post("http://127.0.0.1:7000/reportes/get_facturas_layout/", data)
                .then(res => {
                if (typeof res.data !== "undefined") {
                    this.datos_bitacora = res.data;
                    for (var k in this.datos_bitacora) {
                        this.datos_bitacora[k].created_at = this.parseDate(this.datos_bitacora[k].created_at);
                        this.datos_bitacora[k].estatus = this.datos_bitacora[k].error==1?"Con Errores":"Correcto"; 
                    }

                }
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener la bitacora.",
                    footer: ""
                });
                console.log(err);

                }).then(() => {
                    this.cargarReportes();
                });
        },
        downloadFile: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = "_blank";
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    }
    
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>